import Vue from 'vue'

export default class ApiUsageActivity {
  constructor() {
    this.series = []
    this.summarySeries = null
    this.start_time = ''
    this.end_time = ''
    this.interval = 'raw'
    this.tokens = []
    this.endpoints = []
    this.filterActive = false
    this.filterDegraded = null
    this.selectionTruncated = false
    this.showSummed = false

    this.tokenTotals = []
    this.endpointTotals = []
    this.daily = []
    this.quotaPeriods = []
    this.correlationCoverage = null
    this.truncated = false
  }

  hasChartData() {
    const visible = this.visibleSeries()
    return visible.some((item) => item.values && item.values.length > 0)
  }

  visibleSeries() {
    if (this.showSummed && this.summarySeries && this.summarySeries.values) {
      return [{
        kind: 'summary',
        label: this.summarySeries.label || 'Filtered total',
        values: this.summarySeries.values,
      }]
    }
    return this.series || []
  }

  chartData() {
    return this.visibleSeries().map((item, index) => ({
      device_index: item.kind === 'token' || item.kind === 'pair' ? index : -1,
      metric_index: item.kind === 'route' ? index : (item.kind === 'summary' || item.kind === 'total' ? 0 : -1),
      metric_name: item.id || item.label,
      label: item.label,
      data: (item.values || []).map((point) => ({
        x: point.timestamp || null,
        y: point.value == null ? null : Number(point.value),
      })),
    }))
  }

  fetch() {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/usage/query', {
        start_time: this.start_time,
        end_time: this.end_time,
        interval: this.interval,
        tokens: this.tokens,
        endpoints: this.endpoints,
      }).then((result) => {
        const data = result.data || {}
        this.series = data.series || []
        this.summarySeries = data.summary_series || null
        this.interval = data.interval || this.interval
        this.filterActive = !!(data.filter && data.filter.active)
        this.filterDegraded = (data.filter && data.filter.degraded) || null
        this.selectionTruncated = !!(data.filter && data.filter.selection_truncated)
        this.tokenTotals = data.tokens || []
        this.endpointTotals = data.endpoints || []
        this.daily = data.daily || []
        this.quotaPeriods = data.quota_periods || []
        this.correlationCoverage = data.correlation_coverage || null
        this.truncated = !!data.truncated
        resolve(this.series)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}
